import { useEffect } from "react";
import MainLayout from "../../../../layouts/MainLayout";
import { useNavigate, useParams } from "react-router-dom";
import "../../../../assets/styles/custom-styles.css";
import useNotification from "../../../../hooks/useNotification";
import useLoader from "../../../../hooks/useLoader";
import useForm from "../../../../hooks/useForm";
import { detailsShipmentItemFields } from "../../../../constants/forms/shipmentItemFields";
import { setDefaultFieldValues } from "../../../../utils/objectUtils";
import useBaseService from "../../../../hooks/services/useBaseService";
import { entities } from "../../../../constants/entities";
import PageHeader from "../../../../components/PageHeader";
import DetailsSectionRenderer from "../../../../components/DetailsSectionRenderer";
import useQueryWithLoader from "../../../../hooks/useQueryWithLoader";

const DetailsShipmentItemPage = () => {
  const { shipmentId, itemId } = useParams();
  const navigate = useNavigate();
  const { showNotification } = useNotification();
  const { showLoader, hideLoader } = useLoader();
  const { formData, formatData } = useForm(
    setDefaultFieldValues(detailsShipmentItemFields),
  );

  const { getByColumn: baseServiceGetByColumn } = useBaseService(navigate);

  // --- Query para buscar detalhes do Item de Carregamento ---
  const {
    data: shipmentItemDetails,
    isLoading: isLoadingShipmentItem,
    isFetching: isFetchingShipmentItem,
    isError: isErrorShipmentItem,
    error: errorShipmentItem,
  } = useQueryWithLoader({
    queryKey: ["shipmentItemDetails", shipmentId, itemId],
    queryFn: async () => {
      // Usando a entidade corrigida para buscar o item de carregamento
      const response = await baseServiceGetByColumn(
        entities.shipments.items.getById(shipmentId, itemId),
      );
      return response.result;
    },
    enabled: !!shipmentId && !!itemId,
    staleTime: 5 * 60 * 1000, // 5 minutos de cache
  });

  // --- useEffect para tratar erros na busca de detalhes do item de carregamento ---
  useEffect(() => {
    if (isErrorShipmentItem && errorShipmentItem) {
      showNotification(
        "error",
        errorShipmentItem.message ||
          "Erro ao carregar os dados do item de carregamento.",
      );
      console.error(
        "Erro no carregamento dos dados do item de carregamento:",
        errorShipmentItem,
      );
    }
  }, [isErrorShipmentItem, errorShipmentItem, showNotification]);

  // --- useEffect para formatar os dados no formulário ---
  useEffect(() => {
    if (shipmentItemDetails) {
      const formattedData = {
        ...shipmentItemDetails,
        item_name: shipmentItemDetails.item_name || "-",
        address: shipmentItemDetails.address || "-",
        location: shipmentItemDetails.location || "-",
      };
      formatData(formattedData, detailsShipmentItemFields);
    }
  }, [shipmentItemDetails, formatData]);

  // --- Gerenciamento do Loader Global ---
  useEffect(() => {
    if (isLoadingShipmentItem || isFetchingShipmentItem) {
      showLoader();
    } else {
      hideLoader();
    }
  }, [isLoadingShipmentItem, isFetchingShipmentItem, showLoader, hideLoader]);

  // Define a URL de retorno dinamicamente
  const backUrl = `/aluguel/carregamentos/${shipmentId}/detalhes/`;

  return (
    <MainLayout selectedCompany="ALUCOM">
      <PageHeader
        title={`Detalhes do Equipamento do Carregamento #${shipmentId}`}
        showBackButton={true}
        backUrl={backUrl}
      />
      <div className="container-fluid p-1">
        {isLoadingShipmentItem ? (
          <div>Carregando detalhes do item de carregamento...</div>
        ) : (
          <DetailsSectionRenderer
            formData={formData}
            sections={detailsShipmentItemFields}
            readOnly
          />
        )}
      </div>
    </MainLayout>
  );
};

export default DetailsShipmentItemPage;
